const feedbackText = {
  English: {
    headerTitle: "Share feedback for",
    headerDescription: "Below is the list of services and applications that you have selected to share the feedback on.",
    thankYouMessage: "Thank you for your response!",
    alertMessage: "At least one option must remain.",
  },
  
  Chinese: {
    headerTitle: "分享回馈意见给",
    headerDescription: "以下是您选择分享反馈的服务和应用程序列表。",
    thankYouMessage: "感谢您的反馈！",
    alertMessage: "至少需要保留一个选项。",
  },
  
  Dutch: {
    headerTitle: "Deel feedback voor",
    headerDescription: "Hieronder staat de lijst met services en applicaties die u hebt geselecteerd om feedback over te delen.",
    thankYouMessage: "Bedankt voor uw reactie!",
    alertMessage: "Er moet minimaal één optie overblijven.",
  },
  
  French: {
    headerTitle: "Partager des commentaires pour",
    headerDescription: "Vous trouverez ci-dessous la liste des services et applications que vous avez sélectionnés pour partager vos commentaires.",
    thankYouMessage: "Merci pour votre réponse!",
    alertMessage: "Au moins une option doit rester.",
  },
  
  Spanish: {
    headerTitle: "Compartir comentarios para",
    headerDescription: "A continuación se muestra la lista de servicios y aplicaciones que has seleccionado para compartir comentarios.",
    thankYouMessage: "¡Gracias por su respuesta!",
    alertMessage: "Debe quedar al menos una opción.",
  },
  
  German: {
    headerTitle: "Feedback geben für",
    headerDescription: "Unten finden Sie die Liste der Dienste und Anwendungen, für die Sie Feedback teilen möchten.",
    thankYouMessage: "Vielen Dank für Ihre Antwort!",
    alertMessage: "Mindestens eine Option muss verbleiben.",
  },
  
  Japanese: {
    headerTitle: "フィードバックを共有する",
    headerDescription: "以下は、フィードバックを共有するために選択したサービスとアプリケーションのリストです。",
    thankYouMessage: "ご回答ありがとうございます！",
    alertMessage: "少なくとも1つのオプションが残っている必要があります。",
  },}
  
  
  export default feedbackText;
  